import { render, staticRenderFns } from "./InternetRegistration.vue?vue&type=template&id=e6312fde"
import script from "./InternetRegistration.vue?vue&type=script&lang=js"
export * from "./InternetRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports